var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w100"},[_c('van-nav-bar',{attrs:{"title":_vm.$t('wallet.withdraw'),"fixed":true,"left-arrow":""},on:{"click-left":_vm._back}}),_c('div',{staticClass:"scroll-wrapper"},[_c('van-cell-group',_vm._l((_vm.listData),function(item,index){return _c('van-cell',{key:index,attrs:{"icon":require('@/assets/images/wallet/withdraw/icon_' +
            (index == 0
              ? 'withdraw'
              : index == 1
              ? 'order'
              : index == 2
              ? 'bank'
              : 'alipay') +
            '@2x.png'),"title":item.type_name,"label":item.detail,"is-link":""},nativeOn:{"click":function($event){return _vm.linkFun(item, index)}}})}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }